module.exports = __webpack_public_path__ + "static/media/IMG_0616_Reduced.0acb1346.jpg";